import React from 'react';
import '../../styles/Hospitalar.css';

export function HospitalarIcon({ type = 'bed' }) {
  const paths = { bed: 'M3 18V6m0 8h18v4M3 10h5v4m0-6h10a3 3 0 013 3v3M3 18v3m18-3v3', structure: 'M12 3v5M5 16v-5h14v5M3 17h4v4H3zm7 0h4v4h-4zm7 0h4v4h-4zM10 3h4v4h-4z', settings: 'M8 4h12v17H4V4h4m0-2h8v4H8zm0 9h8m-8 4h8' };
  return <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={paths[type] || paths.bed}/></svg>;
}

export default function HospitalarHero({ title, description, unit, icon, actions }) {
  return <header className="hospitalar-hero">
    <div className="hospitalar-hero-main"><span className="hospitalar-hero-icon"><HospitalarIcon type={icon}/></span>
      <div><span className="hospitalar-eyebrow">Fluxo Clínica · Hospitalar</span><h1>{title}</h1><p>{description}</p>{unit && <span className="hospitalar-unit"><span/>Unidade: {unit}</span>}</div>
    </div>{actions && <div className="hospitalar-hero-actions">{actions}</div>}
  </header>;
}
